import { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            BonnyCloud
          </h1>
          <p className="text-gray-600">
            Thermal printer management platform
          </p>
        </div>
        
        {children}
      </div>
    </div>
  )
}

export default AuthLayout